import { LitElement, html, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'

@customElement('zaptic-deleted-assignee')
export class DeletedAssignee extends LitElement {
    @property({ type: String })
    label: string

    static styles = css`
        :host {
            display: flex;
        }

        .container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding: 4px 12px;
            color: var(--grey5);
            border-radius: 21px;
            border: 1px dashed var(--grey5);
            background-color: var(--grey8);
        }

        zaptic-delete-icon {
            margin-left: 5px;
        }
    `

    private handleClick() {
        return () => {
            const event = new CustomEvent('onClick')
            this.dispatchEvent(event)
        }
    }

    render() {
        return html`
            <div class="container" }>
                ${this.label}
                <zaptic-delete-icon @click=${this.handleClick()}></zaptic-delete-icon>
            </div>
        `
    }
}
